var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.colourScheme,attrs:{"id":"app"}},[_c('Competition',{attrs:{"msg":"DCB Mini CTF 4","sub":"Language Translation"}}),_c('Points',{attrs:{"score":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }